import type {TimeZone} from '@hconnect/common/types'
import {getSystemTimezone} from '@hconnect/common/utils/datetime.utils'
import {useContext} from 'react'

import {UpmPlantContext} from '../contexts'
import type {UpmPlant} from '../types'

import {useUpmPlantsContext} from './useUpmPlantsContext'

/**
 * Returns the timezone for a plant, with system timezone as fallback.
 *
 * @overload Zero-param — reads from UpmPlantProvider context
 * @overload With `plantUpmId` — explicit lookup by UPM ID
 * @overload With `plantId` string — deprecated legacy lookup
 */
export function useUpmPlantTimezone(): TimeZone
export function useUpmPlantTimezone(params: {plantUpmId: string}): TimeZone
/** @deprecated Use `useUpmPlantTimezone({plantUpmId})` or zero-param context version instead. */
export function useUpmPlantTimezone(plantId: string): TimeZone
export function useUpmPlantTimezone(paramsOrPlantId?: string | {plantUpmId: string}): TimeZone {
  const contextPlant = useContext(UpmPlantContext)
  const plants = useUpmPlantsContext()

  if (paramsOrPlantId === undefined) {
    if (!contextPlant) {
      throw new Error('useUpmPlantTimezone: No UpmPlantProvider found when called without params')
    }
    return contextPlant.timezone || getSystemTimezone()
  }

  let upmPlant: UpmPlant | undefined
  if (typeof paramsOrPlantId === 'string') {
    upmPlant = plants[paramsOrPlantId]
  } else {
    upmPlant = Object.values(plants).find((p) => p.upmId === paramsOrPlantId.plantUpmId)
  }

  return upmPlant?.timezone || getSystemTimezone()
}
